export default "__VITE_ASSET__CeHd73SN__"